import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";

import { showToast } from "../ToastManager";
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { Fieldset } from 'primereact/fieldset';
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";

import Utils from "../../utilities/Utils";

import UsuarioService from "../../service/UsuarioService";
import RoleService from "../../service/RoleService";
import EmpresaService from '../../service/EmpresaService';
import ConfigsService from '../../service/ConfigsService';

const configService = new ConfigsService(); // Create an instance of PrestadorService
const empresaService = new EmpresaService(); // Create an instance of EmpresaService
const usuarioService = new UsuarioService();

const CadastrarUsuario = () => {
    const iss = localStorage.getItem('iss');
    const idUser = localStorage.getItem('idUser');
    const history = useHistory();

    let usuarioNovo = {
        username: null,
        email: null,
        password: null,
        companyId: null,
        originalCompanyId: null,
        roleId: null,
        originalRoleId: null,
        ativo: null,
        excluido: null,
        isEmpresaAdm: false,
        profile: {
            name: null,
            nickname: null,
            cpf: null,
            gender: null,
            phone: null,
            bio: null,
            location: null
        },
        companiesRoles: [],
    };


    const [usuario, setUsuario] = useState(usuarioNovo);
    const [empresa, setEmpresa] = useState([]);
    const [role, setRole] = useState([]);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [selectedRole, setSelectedRole] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    const { id } = useParams();
    const empresaOptions = selectedEmpresa && !empresa.some(item => item.id === selectedEmpresa.id)
        ? [selectedEmpresa, ...empresa]
        : empresa;

    const initEmpresa = useCallback(async () => {
        setLoading(true);

        try {
            const data = await empresaService.listAllEmpresas(iss);
            const updatedItems = data.data.rows.map(({ categoria_id, categoriaCompany, cnpj, razaoSocial, telefone, endereco, cidade, estado, cep, excluido, ativo, url, createdAt, updatedAt, ...rest }) => rest);
            setEmpresa(updatedItems);
            if (updatedItems.length === 1) {
                usuario.companyId = updatedItems[0].id
                setSelectedEmpresa(updatedItems[0])
            }
        } catch (error) {
            console.error("Erro ao carregar empresas:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar empresas' });
        } finally {
            setLoading(false);
        }
    }, [iss]);

    const initRole = useCallback(async () => {
        setLoading(true);

        try {
            const data = await configService.listAllRoles(iss);

            var updatedItems = [];

            if (data.data.rows != undefined) {
                updatedItems = data.data.rows.map(({ ativo, createdAt, updatedAt, ...rest }) => rest);
            } else {
                updatedItems = [{
                    id: data.data.id,
                    name: data.data.name
                }]
                usuario.roleId = updatedItems[0].id
                setSelectedRole(updatedItems[0])
            }

            setRole(updatedItems);
        } catch (error) {
            console.error("Erro ao carregar roles:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar roles' });
        } finally {
            setLoading(false);
        }
    }, [iss]);

    useEffect(() => {
        initEmpresa();
        initRole();
    }, [initEmpresa, initRole]);


    useEffect(() => {
        const loadAgendaData = async () => {
            if (id && !dataLoaded) {
                try {
                    setLoading(true);
                    setDisable(true)
                    const data = await usuarioService.getUser(iss, id);
                    const usuarioNovo = data.data.rows[0];
                    const companyRole = usuarioNovo.companiesRoles[0];

                    usuarioNovo.companyId = companyRole.company_id
                    usuarioNovo.originalCompanyId = companyRole.company_id
                    usuarioNovo.roleId = companyRole.role_id
                    usuarioNovo.originalRoleId = companyRole.role_id
                    setSelectedEmpresa(companyRole.company)
                    setSelectedRole(companyRole.role)
                    setTimeout(() => {
                        setUsuario(usuarioNovo);
                    }, 200);
                    setDataLoaded(true);
                } catch (error) {
                    console.error("Erro ao carregar dados:", error);
                } finally {
                    setLoading(false);
                }
            }
        }
        loadAgendaData();
    }, [dataLoaded, id, iss]);

    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';

        if (checkbox) {
            val = e.checked;
        }

        if (name === 'companyId') {
            setSelectedEmpresa(e.value)
            val = e.value.id;
        }

        if (name === 'roleId') {
            setSelectedRole(e.value)
            val = e.value.id;
        }

        let _usuario = { ...usuario };
        // Verifica se o nome tem um ponto
        if (name.includes('.')) {
            const [parent, child] = name.split('.'); // Divide o nome em pai e filho
            if (!_usuario[parent]) {
                _usuario[parent] = {}; // Cria o objeto pai se não existir
            }
            _usuario[parent][child] = val; // Define o valor do atributo filho
        } else {
            if (list) {
                _usuario[name] = val;
            } else {
                _usuario[name] = val; // Define o valor diretamente se não houver aninhamento
            }

        }

        setUsuario(_usuario);

    }

    const cadastrar = () => {
        setSubmitted(true);
        if (usuario.username && usuario.email && usuario.companyId && usuario.roleId) {
            let { status, profile, companiesRoles, ..._usuario } = usuario;

            setLoading(true)
            if (usuario.id != null) {
                usuarioService.changeRoleUser(iss, _usuario, usuario.id).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de usuário', detail: 'Usuário editada com sucesso' });
                    history.push('/usuarios/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar usuário' });
                }).finally(() => { setLoading(false) });
            } else {
                usuarioService.postUser(iss, _usuario).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de usuário', detail: 'Usuário cadastrada com sucesso' });
                    history.push('/usuarios/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            }
        }
    }

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return email && emailRegex.test(email);
    };

    const verificaSeExisteEmail = async (e) => {
        let val = (e.target && e.target.value) || '';

        // Atualiza o estado do campo imediatamente para melhorar a experiência do usuário
        onInputChange(e, 'email');

        // Verifica se é um email válido antes de fazer a requisição
        if (val && val.includes('@') && val.includes('.')) {
            try {
                setLoading(true);
                const search = `email=${val}`;
                const data = await usuarioService.getUserFilter(iss, search);

                if (data.data.count > 0) {
                    showToast({
                        severity: 'error',
                        summary: 'Conflito',
                        detail: 'Email já cadastrado'
                    });
                    // Opcional: limpar o campo ou marcar como inválido
                    setUsuario(prev => ({ ...prev, email: '' }));
                }
            } catch (error) {
                console.error('Erro ao verificar email:', error);
                showToast({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao verificar disponibilidade do email'
                });
            } finally {
                setLoading(false);
            }
        }
    };

    const verificaSeExisteCPF = async (e) => {
        let val = (e.target && e.target.value) || '';

        const cpfLimpo = String(val).replace(/[^\d]/g, '');

        if (cpfLimpo.length === 11) {
            try {
                setLoading(true);
                const search = `cpf=${cpfLimpo}`;
                const data = await usuarioService.getUserFilter(iss, search);

                if (data.data.count > 0) {
                    showToast({
                        severity: 'error',
                        summary: 'Conflito',
                        detail: 'CPF já cadastrado'
                    });
                    setUsuario(prev => ({ ...prev, profile: { cpf: '' } }));
                }
            } catch (error) {
                console.error('Erro ao verificar CPF:', error);
                showToast({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao verificar disponibilidade do CPF'
                });
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="grid">
            <h4>Informações do usuário</h4>
            <div className="col-12">
                <div className="card">
                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText value={usuario.username} onChange={(e) => onInputChange(e, 'username')}
                                    className={classNames({ 'p-invalid': submitted && !usuario.username })} required id="username" type="text" disabled={disable}
                                />
                                <label htmlFor="nome">Nome de usuário</label>
                            </span>
                            {submitted && !usuario.username && <small className="p-invalid">Nome de usuário é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-6">
                            <span className="p-float-label">
                                <InputText value={usuario.email}
                                    onChange={(e) => verificaSeExisteEmail(e)}
                                    className={classNames({
                                        'p-invalid': submitted && (!usuario.email || !isValidEmail(usuario.email))
                                    })}
                                    required
                                    id="email"
                                    type="email" />
                                <label htmlFor="email">Email</label>
                            </span>
                            {submitted && !usuario.email &&
                                <small className="p-invalid">Email é obrigatório.</small>}


                            {submitted && usuario.email != null && !usuario.email.includes('@') &&
                                <small className="p-invalid">Email inválido.</small>}

                        </div>
                        {/* <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputText value={usuario.password} onChange={(e) => onInputChange(e, 'password')}
                                    className={classNames({ 'p-invalid': submitted && !usuario.password })} required id="password" type="text" disabled={disable}

                                />
                                <label htmlFor="nome">Senha</label>
                            </span>
                            {submitted && !usuario.password && <small className="p-invalid">Senha é obrigatório.</small>}
                        </div> */}
                        <div style={{ marginTop: 20 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <Dropdown dataKey="id" optionLabel="name" value={selectedEmpresa}
                                    className={classNames({ 'p-invalid': submitted && !usuario.companyId })}
                                    options={empresaOptions}
                                    onChange={(e) => {
                                        onInputChange(e, 'companyId')
                                    }} />
                                <label htmlFor="companyId">Empresa</label>
                            </span>
                            {submitted && !selectedEmpresa &&
                                <small className="p-invalid">Empresa é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 20 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <Dropdown optionLabel="name" value={selectedRole}
                                    className={classNames({ 'p-invalid': submitted && !usuario.roleId })}
                                    options={role}
                                    onChange={(e) => {
                                        onInputChange(e, 'roleId')
                                    }} />
                                <label htmlFor="roleId">Perfil de acesso</label>
                            </span>
                            {submitted && !selectedRole &&
                                <small className="p-invalid">Perfil de acesso é obrigatório.</small>}
                        </div>
                        {RoleService.isAdmin() && (<div className="col-12 md:col-4">
                            <div className="field-checkbox">
                                <Checkbox inputId="isEmpresaAdm" name="isEmpresaAdm"
                                    checked={usuario.isEmpresaAdm}
                                    onChange={(e) => {
                                        onInputChange(e, 'isEmpresaAdm', false, true)
                                    }} />
                                <label htmlFor="isEmpresaAdm">Usuário administrador da empresa</label>
                            </div>
                        </div>)}
                        {disable && (
                            <>
                                <div className="col-12">
                                    <div className="card">
                                        <h5>Perfil</h5>
                                        <Fieldset>
                                            <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                                                <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                                                    <span className="p-float-label">
                                                        <InputText value={usuario.profile.name} id="usuario.profile.name" type="text" disabled={disable} />
                                                        <label htmlFor="name">Nome</label>
                                                    </span>
                                                </div>
                                                <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                                                    <span className="p-float-label">
                                                        <InputMask
                                                            onChange={(e) => { onInputChange(e, 'cpf'); }}
                                                            onBlur={(e) => { verificaSeExisteCPF(e); }}
                                                            value={Utils.formatCpf(usuario.profile.cpf)}
                                                            required
                                                            className={classNames({ 'p-invalid': submitted && !usuario.profile.cpf })}
                                                            id="cpf"
                                                            type="text"
                                                            mask={"999.999.999-99"}
                                                            unmask={false}
                                                        />
                                                        {/* <InputMask value={Utils.formatCpf(usuario.profile.cpf)} id="usuario.profile.cpf" type="text"
                                                            disabled={disable} mask={"999.999.999-99"}
                                                        /> */}
                                                        <label htmlFor="usuario.profile.cpf">CPF</label>
                                                    </span>
                                                </div>
                                                <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                                                    <span className="p-float-label">
                                                        <InputText value={usuario.profile.gender} id="usuario.profile.gender" type="text" disabled={disable} />
                                                        <label htmlFor="usuario.profile.gender">Gênero</label>
                                                    </span>
                                                </div>
                                                <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                                                    <span className="p-float-label">
                                                        <InputMask value={usuario.telefone}
                                                            disabled={disable}
                                                            mask={"(99) 9.9999-9999"}
                                                            id="telefone" type="text" />
                                                        <label htmlFor="telefone">Telefone</label>
                                                    </span>
                                                </div>
                                            </div>
                                        </Fieldset>
                                    </div>
                                </div>
                            </>
                        )

                        }

                        {/* <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputMask value={usuario.data_nascimento} onChange={(e) => onInputChange(e, 'data_nascimento')}
                                    mask={"99/99/9999"} id="data_nascimento" type="text" />
                                <label htmlFor="data_nascimento">Data Nascimento</label>
                            </span>
                        </div> */}

                        <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarUsuario, comparisonFn);
